import {FreeMode, Navigation, Thumbs} from 'swiper/modules';
import {useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {AspectRatio} from '@chakra-ui/react';
import Image from 'next/image';
import s from './ImageSlides.module.css';

const ImageSlides = ({imageUrls}) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <>
      <AspectRatio
        ratio={4 / 3}
        margin={'5px 0'}>
        <Swiper
          thumbs={{swiper: thumbsSwiper &&
                  !thumbsSwiper.destroyed ? thumbsSwiper : null}}
          modules={[FreeMode, Navigation, Thumbs]}
          className={s.slides}>
          {imageUrls.map((url, index) => {
            return (
              <SwiperSlide
                key={`swiper-image-${index}`}>
                <Image
                  src={url}
                  alt={'image'}
                  className={s.image}
                  fill={true}/>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </AspectRatio>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={5}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className={`thumb-slides`}>
        {imageUrls.map((url, index) => (
          <SwiperSlide key={`swiper-thumb-${index}`}>
            <AspectRatio
              ratio={4 / 3}
              position={'relative'}>
              <Image
                src={url}
                alt={'thumb'}
                className={s.image}
                fill={true}/>
            </AspectRatio>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default ImageSlides;
